<template>
  <div class="booking-price">
    <LocationPrice :label="label" :amount="amount" :locationId="locationId" :darkMode="darkMode" :beforeTax="beforeTax" />
    <UICheckbox
      v-if="lastFours.length === 0 || !paid"
      @change="toggleMarkAsPaid"
      :value="paid"
      :darkMode="darkMode"
      :title="$t('Mark as paid')"
    />
    <div class="paidwith f6 " v-else>
      <span>{{ $t('Paid with:') }}</span>
      <span v-for="(lastFour, index) of lastFours" :key="lastFour">
        <span v-if="index === 0">{{ lastFour }}</span>
        <span v-else>{{ $t('and') }} {{ lastFour }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import LocationPrice from './LocationPrice';
import UICheckbox from '@/core/shared/components/ui/UICheckbox';

export default {
  components: {
    LocationPrice,
    UICheckbox,
  },
  props: {
    locationId: {
      type: String,
      required: true,
    },
    bookingStationTimes: {
      type: Array,
      required: true,
    },
    beforeTax: {
      type: Boolean,
      default: false,
    },
    darkMode: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    paid () {
      return this.bookingStationTimes.reduce((price, bookingStationTime) => {
        return price + bookingStationTime.amountDue;
      }, 0) === 0;
    },
    amount () {
      return (this.paid)
        ? this.bookingStationTimes.reduce((price, bookingStationTime) => { return price + bookingStationTime.amountPaid; }, 0)
        : this.bookingStationTimes.reduce((price, bookingStationTime) => { return price + bookingStationTime.amountDue; }, 0);
    },
    label () {
      return (this.paid) ? this.$t('Amount Paid') : this.$t('Amount Unpaid');
    },
    lastFours () {
      return this.bookingStationTimes.reduce((lastFours, bookingStationTime) => {
        if (bookingStationTime.customerCard && !lastFours.includes(bookingStationTime.customerCard.lastFour)) lastFours.push(bookingStationTime.customerCard.lastFour);
        return lastFours;
      }, []);
    },
  },
  methods: {
    toggleMarkAsPaid (e) {
      e.preventDefault();

      this.$emit('toggleMarkAsPaid', this.paid);
    },
  },
};
</script>

<style scoped lang="postcss">
@import "core/shared/styles";

.booking-price {
  margin-right: var(--spacingSm);

  & .paidwith {
    margin: 0;
    color: var(--colorGeyser);
  }
}

</style>
